module.exports = __webpack_public_path__ + "img/miracle.fd4b3ec8.jpg";